import React, { useState, useEffect } from 'react';
import { CDBIcon, CDBSidebar, CDBSidebarContent, CDBSidebarFooter, CDBSidebarHeader, CDBSidebarMenu, CDBSidebarMenuItem } from 'cdbreact';
import { NavLink, useNavigate } from 'react-router-dom';
import { Modal, Button, Container } from 'react-bootstrap';
import isotipo from '../../img/isotipo.png';
import Peiixmasterlogo from '../../img/Peiixmasterlogo.png';


const SideBarManager = () => {
    const [showModal, setShowModal] = useState(false);
    const [userTokens, setUserTokens] = useState(() => {
        try {
            const tokens = localStorage.getItem('user_tokens_related');
            return tokens ? JSON.parse(tokens) : [];
        } catch {
            return [];
        }
    });
    const [userRole] = useState(() => localStorage.getItem('user_role') || '');
    const [isAccount] = useState(() => localStorage.getItem('is_account') === 'true');
    const [isAggregator] = useState(() => localStorage.getItem('is_aggregator') === 'true');
    const [provider] = useState(() => localStorage.getItem('provider') || '');
    const [showHelpModal, setShowHelpModal] = useState(false);
    const handleShowHelpModal = () => setShowHelpModal(true);
    const handleCloseHelpModal = () => setShowHelpModal(false);
    const [showHelpContent, setShowHelpContent] = useState('novedades'); // 'novedades' or 'ayuda'
    const navigate = useNavigate();
    const [openSmartlinks, setOpenSmartlinks] = useState(false);

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('access_token');
        localStorage.removeItem('bp_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('nombre_comercial');
        localStorage.removeItem('user_tokens_related');
        localStorage.removeItem('selectedSucursal');
        localStorage.removeItem('cliente_id');
        localStorage.removeItem('provider');
        navigate('/Inicio');
    };

    return (
        <>
            <div style={{ display: 'flex', overflow: 'scroll initial' }}>
                <CDBSidebar backgroundColor="#F6F6F6" textColor="#E7F5E6">
                    <CDBSidebarHeader prefix={<i className="fa fa-bars" style={{ color: '#3e3e3e' }} />}>
                        <div className='h2 fw-bold' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10px', color: '#0E9600' }}>MASTER</div>
                    </CDBSidebarHeader>

                    <CDBSidebarContent className="sidebar-content">
                        <CDBSidebarMenu>
                            <>
                                {userRole === 'SUPERADMIN' && (
                                    <NavLink to="/Master/Inicio" className={({ isActive }) => isActive ? 'activeClicked' : ""}>
                                        {({ isActive }) => (
                                            <CDBSidebarMenuItem icon="home" style={{ color: isActive ? '#0E9600' : '#3e3e3e' }}><strong>Inicio</strong></CDBSidebarMenuItem>
                                        )}
                                    </NavLink>
                                )}
                                {((userRole === 'ADMIN' || userRole === 'CONTABILIDAD') && (!isAccount && !isAggregator)) && (
                                    <NavLink to="/Master/Depositos" className={({ isActive }) => isActive ? 'activeClicked' : ""}>
                                        {({ isActive }) => (
                                            <CDBSidebarMenuItem icon="dollar-sign" style={{ color: isActive ? '#0E9600' : '#3e3e3e' }}><strong>Depósitos</strong></CDBSidebarMenuItem>
                                        )}
                                    </NavLink>
                                )}
                                {(userRole === 'ADMIN' || userRole === 'GERENTE' || userRole === 'CAJERO' || userRole === 'USUARIO') && (
                                    <NavLink to="/Master/Transacciones" className={({ isActive }) => isActive ? 'activeClicked' : ""}>
                                        {({ isActive }) => (
                                            <CDBSidebarMenuItem icon="exchange-alt" style={{ color: isActive ? '#0E9600' : '#3e3e3e' }}><strong>Transacciones</strong></CDBSidebarMenuItem>
                                        )}
                                    </NavLink>
                                )}
                                {(userRole === 'ADMIN' || userRole === 'GERENTE') && (!isAccount && !isAggregator) && provider === 'Blumon' && (
                                    <NavLink to="/Master/Recurrentes" className={({ isActive }) => isActive ? 'activeClicked' : ""}>
                                        {({ isActive }) => (
                                            <CDBSidebarMenuItem icon="redo" style={{ color: isActive ? '#0E9600' : '#3e3e3e' }}><strong>Pagos Recurrentes</strong></CDBSidebarMenuItem>
                                        )}
                                    </NavLink>
                                )}
                                
                                {((userRole === 'ADMIN' || userRole === 'USUARIO')  && (!isAccount && !isAggregator)) && (
                    <>
                    
                    {/* Botón principal del submenu */}
                                        <div
                                            onClick={() => setOpenSmartlinks(!openSmartlinks)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <CDBSidebarMenuItem
                                                icon="link"
                                                style={{ color: openSmartlinks ? '#0E9600' : '#3e3e3e' }}
                                            >
                                                <strong>SmartLinks</strong>
                                            </CDBSidebarMenuItem>
                                        </div>

                                        {/* Submenú interno */}
                                        {openSmartlinks && (
                                            <div style={{ paddingLeft: '25px' }}>
                                                <NavLink
                                                    to="/Master/Smartlinks"
                                                    className={({ isActive }) => isActive ? 'activeClicked' : ""}
                                                >
                                                    {({ isActive }) => (
                                                        <CDBSidebarMenuItem
                                                            style={{ color: isActive ? '#0E9600' : '#3e3e3e' }}
                                                        >
                                                            Crear SmartLinks
                                                        </CDBSidebarMenuItem>
                                                    )}
                                                </NavLink>
                                                <NavLink
                                                    to="/Master/SmartlinksList"
                                                    className={({ isActive }) => isActive ? 'activeClicked' : ""}
                                                >
                                                    {({ isActive }) => (
                                                        <CDBSidebarMenuItem
                                                            style={{ color: isActive ? '#0E9600' : '#3e3e3e' }}
                                                        >
                                                            SmartLinks creados
                                                        </CDBSidebarMenuItem>
                                                    )}
                                                </NavLink>

                                                <NavLink
                                                    to="/Master/LinksView"
                                                    className={({ isActive }) => isActive ? 'activeClicked' : ""}
                                                >
                                                    {({ isActive }) => (
                                                        <CDBSidebarMenuItem
                                                            style={{ color: isActive ? '#0E9600' : '#3e3e3e' }}
                                                        >
                                                            Transacciones 
                                                        </CDBSidebarMenuItem>
                                                    )}
                                                </NavLink>

                                            </div>
                                        )}
                                    </>
                                )}


                                
                                {(userRole === 'SUPERADMIN') && (
                                    <NavLink to="/Master/Facturas" className={({ isActive }) => isActive ? 'activeClicked' : ""}>
                                        {({ isActive }) => (
                                            <CDBSidebarMenuItem icon="file-alt" style={{ color: isActive ? '#0E9600' : '#3e3e3e' }}><strong>Facturas</strong></CDBSidebarMenuItem>
                                        )}
                                    </NavLink>
                                )}
                                {userRole === 'SUPERADMIN' && (
                                    <NavLink to="/Master/Aclaraciones" className={({ isActive }) => isActive ? 'activeClicked' : ""}>
                                        {({ isActive }) => (
                                            <CDBSidebarMenuItem icon="users" style={{ color: isActive ? '#0E9600' : '#3e3e3e' }}><strong>Aclaraciones</strong></CDBSidebarMenuItem>
                                        )}
                                    </NavLink>
                                )}
                                {userRole === 'PBO' && (
                                    <NavLink to="/Master/Clientes" className={({ isActive }) => isActive ? 'activeClicked' : ""}>
                                        {({ isActive }) => (
                                            <CDBSidebarMenuItem icon="user-friends" style={{ color: isActive ? '#0E9600' : '#3e3e3e' }}><strong>Clientes</strong></CDBSidebarMenuItem>
                                        )}
                                    </NavLink>
                                )}
                                {userRole === 'PBO' && (
                                    <NavLink to="/Master/TransaccionesPBO" className={({ isActive }) => isActive ? 'activeClicked' : ""}>
                                        {({ isActive }) => (
                                            <CDBSidebarMenuItem icon="exchange-alt" style={{ color: isActive ? '#0E9600' : '#3e3e3e' }}><strong>Transacciones Clientes</strong></CDBSidebarMenuItem>
                                        )}
                                    </NavLink>
                                )}
                            </>
                        </CDBSidebarMenu>

                    </CDBSidebarContent>
                    <CDBSidebarFooter>
                        <CDBSidebarMenu>
                            {/* New Help Item */}
                            <div onClick={handleShowHelpModal} style={{ cursor: 'pointer' }}>
                                <CDBSidebarMenuItem icon="exclamation-circle" style={{ color: '#3e3e3e' }}><strong>Ayuda y Novedades</strong></CDBSidebarMenuItem>
                            </div>
                            <div onClick={handleShowModal} style={{ cursor: 'pointer' }}>
                                <CDBSidebarMenuItem icon='sign-out-alt' style={{ color: 'red' }}><strong>Cerrar Sesión</strong></CDBSidebarMenuItem>
                            </div>

                        </CDBSidebarMenu>

                        <Modal show={showModal} onHide={handleCloseModal}>
                            <Modal.Body>
                                <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <CDBIcon icon="exclamation-circle" size="7x" style={{ color: '#F1C901' }} />
                                </Container>
                                <br />
                                <Container>
                                    <h3 className="fw-bold" style={{ textAlign: 'center', color: '#3E3E3E' }}>¿Estás seguro de que deseas cerrar sesión?</h3>
                                </Container>
                                <br />
                                <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                    <Button variant="secondary" style={{ background: '#FF4444', border: '#FF4444' }} onClick={handleCloseModal}>
                                        <div className="fw-bold h5">Cancelar</div>
                                    </Button>
                                    <Button variant="primary" style={{ background: '#0E9600', border: '#0E9600' }} onClick={() => { handleLogout(); handleCloseModal(); }}>
                                        <div className="fw-bold h5">Confirmar</div>
                                    </Button>
                                </Container>
                            </Modal.Body>
                        </Modal>

                        {/* Ayuda Modal */}
                        <Modal show={showHelpModal} onHide={handleCloseHelpModal}>
                            <Modal.Body>
                                <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <CDBIcon icon="info-circle" size="7x" style={{ color: '#0E9600' }} />
                                </Container>
                                <br />
                                <Container>
                                    <h3 className="fw-bold" style={{ textAlign: 'center', color: '#3E3E3E' }}>Ayuda y Novedades</h3>
                                </Container>
                                <br />
                                {showHelpContent === 'novedades' ? (
                                    <>
                                        <Container>
                                            <img src={Peiixmasterlogo} alt="Peiix Logo" style={{ width: '350px', height: 'auto', display: 'block', margin: '0 auto' }} />
                                            <br/>
                                            <p style={{ textAlign: 'center', color: '#3E3E3E' }}>
                                                <strong>Versión:</strong> 2.3.0
                                            </p>
                                            <p style={{ textAlign: 'center', color: '#3E3E3E' }}>
                                                <strong>Novedades:</strong>
                                            </p>
                                            <ul style={{ textAlign: 'center', listStylePosition: 'inside', padding: 0 }}>
                                                <li>Optimización de la interfaz de usuario para una mejor experiencia.</li>
                                                {!isAccount && !isAggregator && (
                                                    <>
                                                        {provider === 'Blumon' && (
                                                            <><li>Se agrego la funcionalidad de Pagos Recurrentes. Cualquier duda sobre su funcionamiento, puedes consultar la sección de ayuda.</li>
                                                            <li>Se corrigieron unos datos en la creación de planes recurrentes.</li></>
                                                        )}
                                                        {/*<li>Se agrego la funcionalidad de Smart Links. Cualquier duda sobre su funcionamiento, puedes consultar la sección de ayuda.</li>*/}
                                                        <li>Mejora de funcionalidad en los Smart Links.</li>
                                                    </>
                                                )}
                                            </ul>
                                        </Container>
                                        <br />
                                        <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                            <Button variant="primary" style={{ background: '#0E9600', border: '#0E9600' }} onClick={handleCloseHelpModal}>
                                                <div className="fw-bold h5">Cerrar</div>
                                            </Button>
                                            <Button variant="info" onClick={() => setShowHelpContent('ayuda')}>
                                                <div className="fw-bold h5">Ayuda</div>
                                            </Button>
                                        </Container>
                                    </>
                                ) : (
                                    <>
                                        <Container>
                                            <h4 className="fw-bold" style={{ textAlign: 'center', color: '#3E3E3E' }}>¿Cómo funcionan los Pagos Recurrentes?</h4>
                                            <p style={{ textAlign: 'center', color: '#3E3E3E' }}>
                                                Los pagos recurrentes son pagos que se realizan de forma periódica, es decir, se repiten cada cierto tiempo. Estos pagos son ideales para suscripciones, membresías, servicios recurrentes, etc.
                                            </p>
                                        </Container>
                                        <br />
                                        <Container>
                                            <h4 className="fw-bold" style={{ textAlign: 'center', color: '#3E3E3E' }}>¿Cómo funcionan los SmartLinks?</h4>
                                            <p style={{ textAlign: 'center', color: '#3E3E3E' }}>
                                                Nuestra plataforma nos da la posibilidad de crear links de cobro con un solo clic. Es tan fácil como desplegar el menú SmartLinks y seleccionar una de las tres opciones: crear, consultar creados y consultar transacciones con SmartLinks.
                                            </p>
                                        </Container>
                                        <br />
                                        <Container>
                                            <h4 className="fw-bold" style={{ textAlign: 'center', color: '#3E3E3E' }}>¿Cómo funciona la generación de archivos PDF y Excel?</h4>
                                            <p style={{ textAlign: 'center', color: '#3E3E3E' }}>
                                                Nuestra plataforma te permite generar archivos PDF y Excel de forma sencilla. Simplemente navega a la sección deseada, selecciona los filtros que desees(Fecha y hora siempre serán obligatorios) y haz clic en el botón de exportar. Tus transacciones estarán listas en segundos.
                                            </p>

                                        </Container>
                                        <br />
                                        <Container>
                                            <h4 className="fw-bold" style={{ textAlign: 'center', color: '#3E3E3E' }}>¿Cómo funcionan nuestros filtros?</h4>
                                            <p style={{ textAlign: 'center', color: '#3E3E3E' }}>
                                                Nuestros filtros te permiten personalizar la visualización de tus datos. Puedes filtrar por fecha, estado, tipo de transacción y más. Simplemente selecciona los criterios que deseas aplicar y la tabla se actualizará automáticamente para mostrar solo la información relevante.
                                            </p>
                                        </Container>
                                        <br />
                                        <Container>
                                            <h4 className="fw-bold" style={{ textAlign: 'center', color: '#3E3E3E' }}>¿Cómo se muestran las transacciones?</h4>
                                            <p style={{ textAlign: 'center', color: '#3E3E3E' }}>
                                                Las transacciones se cargan en bloques de 400-500 por página. Los filtros que apliques se mantendrán al cambiar de página, asegurando que siempre veas los datos relevantes.
                                            </p>
                                        </Container>
                                        <br />
                                        <Container>
                                            <p style={{ textAlign: 'center', color: '#3E3E3E' }}>
                                                <strong>Contacto para soporte:</strong>
                                            </p>
                                            <p style={{ textAlign: 'center', color: '#3E3E3E' }}>
                                                <a href="mailto:soporte@peiix.com" style={{ color: '#0E9600', textDecoration: 'none' }}>soporte@peiix.com</a>
                                            </p>
                                        </Container>
                                        <br />
                                        <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                            <Button variant="secondary" style={{ background: '#FF4444', border: '#FF4444' }} onClick={() => setShowHelpContent('novedades')}>
                                                <div className="fw-bold h5">Volver</div>
                                            </Button>
                                            <Button variant="primary" style={{ background: '#0E9600', border: '#0E9600' }} onClick={handleCloseHelpModal}>
                                                <div className="fw-bold h5">Cerrar</div>
                                            </Button>
                                        </Container>
                                    </>
                                )}
                            </Modal.Body>
                        </Modal>
                    </CDBSidebarFooter>
                </CDBSidebar>
            </div>
        </>
    );
};

export default SideBarManager;
